module.exports = __webpack_public_path__ + "static/teresita-de-la-torre-social-07821d0d37d93fbb3d6aebb2e281d6d5.jpg";